<template>

    
    <div class="equipment-view-compliance">
        <b-alert v-if="tierFourAndNoUploads" show variant="danger" class="validation-alert">
            IMPORTANT!  ADDITIONAL ACTION REQUIRED. <br>
            Your Tier 4 (or DPF-retrofitted) equipment requires additional validation.
            To complete this equipment’s registration, you must attach a photo of this equipment's engine label (clearly showing the engine family name), or of the DPF retrofit, in the Uploaded Documents section below.
            The photo will be reviewed by the CAC program for validation prior to mailing your compliance decal.
        </b-alert>

        <b-card no-body>
            <b-card-header class="pod-heading">
                <h5>Compliance Status</h5>
                <div class="heading__buttons" v-if="isAttested">
                    <compliance-badge :compliance="currentCompliance"/>
                </div>
            </b-card-header>
            <b-card-body>
                <template v-if="!isAttested">
                    Equipment details must be attested before determining compliance.
                </template>
                <template v-else-if="currentCompliance">
                    {{ currentCompliance.explanation }}.
                    <div v-if="isCovered">
                        <hr/>
                        <h4>Effective for <span class="compliance-year">{{ currentCompliance.effective }}</span></h4>
                        <span v-if="currentCompliance.status === 'NONCOMPLIANT'">This equipment does not comply with Clean
                            Air Construction emissions standards. Instead of using this equipment on Clean Air Construction
                            projects, please utilize a rental that complies with Clean Air Construction standards, or
                            submit an exemption request below.
                        </span>
                    </div>
                </template>
                <template v-else>
                    Current compliance cannot be determined.
                </template>
            </b-card-body>
        </b-card>

        <b-card no-body
                class="compliance-status"
                v-if="isAttested && isCovered">
            <b-card-header>
                <h5>Past Compliance Status
                    <helper tag="past-compliance"/>
                </h5>
                <b-button v-b-toggle:collapse>
                    <span class="when-opened">
                        <b-icon-chevron-bar-up/>
                    </span>
                    <span class="when-closed">
                        <b-icon-chevron-bar-down/>
                    </span>
                </b-button>
            </b-card-header>
            <b-card-body>
                <b-collapse visible id="collapse">
                    <template v-if="pastCompliances && pastCompliances.length">
                        <compliance-summary :compliance="c"
                                            v-for="c in pastCompliances" :key="c.id"/>
                    </template>
                    <template v-else>
                        Past compliance cannot be determined.
                    </template>
                </b-collapse>
            </b-card-body>
        </b-card>

        <b-card no-body
                class="compliance-status"
                v-if="isAttested && isCovered">
            <b-card-header>
                <h5>Future Compliance Status
                    <helper tag="future-compliance"/>
                </h5>
                <b-button v-b-toggle:collapse>
                    <span class="when-opened">
                        <b-icon-chevron-bar-up/>
                    </span>
                    <span class="when-closed">
                        <b-icon-chevron-bar-down/>
                    </span>
                </b-button>
            </b-card-header>
            <b-card-body>
                <b-collapse visible id="collapse">
                    <template v-if="futureCompliances && futureCompliances.length">
                        <compliance-summary :compliance="c"
                                            v-for="c in futureCompliances" :key="c.id"/>
                    </template>
                    <template v-else>
                        Future compliance cannot be determined.
                    </template>
                </b-collapse>
            </b-card-body>
        </b-card>

    </div>


</template>

<script>
import Vue from 'vue'
import EquipmentFields from '@/models/Equipment'

export default Vue.extend({
    name: 'EquipmentViewCompliance',
    props: {
        equipment: Object
    },
    data () {
        return {
            title: '',
            equipmentFields: EquipmentFields,
            currentYear: new Date().getFullYear(),
            attachments: '',
        }
    },
    computed: {
        isAttested () {
            return this.equipment.attestationStatus === 'ATTESTED'
        },
        compliances() {
            return this.equipment.compliances
        },
        currentCompliance () {
            return this.compliances.find(c => this.currentYear === parseInt(c.effective))
        },
        pastCompliances () {
            return this.compliances.filter(c => this.currentYear > parseInt(c.effective))
        },
        futureCompliances () {
            return this.compliances.filter(c => this.currentYear < parseInt(c.effective))
        },
        isCovered () {
            if (this.currentCompliance) {
                return this.currentCompliance.status !== 'NONCOVERED'
            } else {
                return true
            }
        },
        tierFour() {
            return this.isAttested && (this.equipment.emissionTier === 4 || this.equipment.exhaust_retrofit_type === 'DPF')
        },
        hasUploads() {
            return this.equipment['attachments'].length > 0
        },
        tierFourAndNoUploads() {
            return this.tierFour && !this.hasUploads
        },
    },
})
</script>

<style scoped lang="scss">
    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }

    .validation-alert {
        max-width: 100%;
    }

    .compliance-status {
        .card-header {
            .btn {
                @media (max-width: 575px) {
                    margin-top: .5em;
                }
            }
        }
    }

</style>
